import { convertImageCoordsToRadiants } from '@/utils/coords';

export default {
  options: () => ({}),
  generatePredefines: state => hotspot => ({
    geometry: {
      levels: [{ width: 4000 }],
    },
    view: {
      limit: {
        maxResolution: 1024,
        maxVFox: 100 * (Math.PI / 180),
      },
      params: {
        yaw: convertImageCoordsToRadiants({ x: hotspot.rotation }).yaw,
      },
    },
  }),
  data: state => state.data,
  hotspots: state => state.data.minimaps.flatMap(({ hotspots }) => hotspots),
  findHotspot: (_, getters) => id => getters.hotspots.find(hotspot => hotspot.id === id) || getters.hotspots[0],
  hotspot: (state, getters) => state.hotspot || getters.hotspots[0],
  minimap: (state, getters) =>
    getters.hotspot &&
    state.data.minimaps.find(minimap => minimap.id === getters.hotspot.minimapId),
  scene: (state, getters) =>
    getters.hotspots.findIndex(({ id }) => id === getters.hotspot.id) || 0,
  autorotate: () => ({
    yawSpeed: 0.05,
    yawAccel: 0.01,
    targetPitch: 0,
    targetFov: 1.2,
    // mix option
    idleTimeToMovement: 3000,
  }),
  viewYaw: state => state.viewYaw,
};
